/* ==========================================================================
   Product card routing — U&S Clothing
   assets/card-tidy.js

   A card's Add To Cart posts straight to /cart/add with nothing but a variant
   id. On a customisable product that means the order arrives with no text, no
   artwork and no print position — there is no way for the shopper to supply
   any of it from a grid.

   So: customisable products get "Customise & add to cart" and go to their
   product page. Everything else keeps the button it has and goes straight to
   the cart, which is the fast path most shoppers want.

   Which products are customisable is decided by the same metafields the
   product page uses, read from the product page itself. There is no separate
   list to maintain.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__cardTidyLoaded) return;
  window.__cardTidyLoaded = true;

  var LABEL = 'Customise & add to cart';

  /* A product page carries one of these when it takes personalisation:
       CustomiseConfig-      the wizard
       InlinePersonaliseConfig-  the inline panel
       .pib-wrapper          the theme's own image upload block
       .product__personalize-input   the theme's own text field           */
  var MARKERS = /CustomiseConfig-|InlinePersonaliseConfig-|pib-wrapper|product__personalize-input/;

  /* Cached per session. A collection page has 48 cards and many repeat
     across pages, so without this the same product would be fetched again
     and again. */
  var cache = {};
  try {
    cache = JSON.parse(sessionStorage.getItem('cardTidy') || '{}');
  } catch (e) { cache = {}; }

  function remember(url, needsPage) {
    cache[url] = needsPage;
    try { sessionStorage.setItem('cardTidy', JSON.stringify(cache)); } catch (e) {}
  }

  function checkProduct(url) {
    if (url in cache) return Promise.resolve(cache[url]);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var needsPage = MARKERS.test(html);
        remember(url, needsPage);
        return needsPage;
      })
      .catch(function () { return false; });   /* on error, leave the card alone */
  }

  /* Replace the submit button with a link. A link cannot post the form by
     accident, which a button with a click handler still can. */
  function convert(btn, url) {
    if (btn.tagName === 'A') return;
    var link = document.createElement('a');
    link.href = url;
    link.className = btn.className;
    link.textContent = LABEL;
    link.setAttribute('data-card-tidy', '1');
    btn.parentNode.replaceChild(link, btn);
  }

  function processCard(card) {
    if (card.__cardTidyDone) return;
    card.__cardTidyDone = true;

    var btn = card.querySelector('.fct-card__atc-btn, .card__atc, button[type="submit"]');
    var link = card.querySelector('a[href*="/products/"]');
    if (!btn || !link) return;

    var url = link.getAttribute('href').split('?')[0];

    checkProduct(url).then(function (needsPage) {
      if (needsPage) convert(btn, url);
    });
  }

  function scan() {
    var cards = document.querySelectorAll('.fct-card, .card-wrapper, .card-product');
    Array.prototype.forEach.call(cards, processCard);
  }

  /* Only look at cards once they are near the viewport. A collection page can
     hold 48 of them and fetching every product page on load would be worse
     than the problem being solved. */
  function boot() {
    if (!('IntersectionObserver' in window)) { scan(); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        processCard(e.target);
      });
    }, { rootMargin: '300px' });

    function observeAll() {
      document.querySelectorAll('.fct-card, .card-wrapper, .card-product')
        .forEach(function (c) { if (!c.__cardTidyDone) io.observe(c); });
    }
    observeAll();

    /* collection filters, pagination and carousels all swap cards in */
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; observeAll(); }, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();